import { createReducer } from "reduxsauce";
import Types from "./types";

export const INITIAL_STATE = {
  userGUID: "",
  email: "",
  gender: "",
  parentUserGuid: "",
  countryCD: "",
  currencyCD: "",
  ipAddress: "",
  totalQuestions: 0,
  selectedAnswerCount: 0,
  totalAnswerCount: 0,
  selectedPlan: {},
  assessmentId: "2FAFF0C7-50A3-4827-BAA1-CC70892FA9F2",
  // assessmentId: "3FA85F64-5717-4562-B3FC-2C963F66AFA6",
  assessmentAttemptId: "",
  isQuizComplete: false,
  isConfirmationView: false,
  backButtonClickCount: 0,
  isGuestUser: false,
  prefillEmail: "",
  userIdSearchByAdmin: "",
  assessmentMapId: "",
};

export const quack = (state = INITIAL_STATE) => {
  return { ...state, isLoading: true };
};

export const setFunnelStepComplete = (
  state = INITIAL_STATE,
  { funnelStepsComplete }
) => {
  return {
    ...state,
    funnelStepsComplete,
  };
};

export const setNumberOfQuestions = (
  state = INITIAL_STATE,
  { totalQuestions }
) => {
  return {
    ...state,
    totalQuestions,
  };
};

export const setQuizComplete = (state = INITIAL_STATE, { quizComplete }) => {
  return {
    ...state,
    isQuizComplete: quizComplete,
  };
};

export const setGuestUser = (state = INITIAL_STATE, { guestUser }) => {
  return {
    ...state,
    isGuestUser: guestUser,
  };
};

export const setUserIdSearchByAdmin = (state = INITIAL_STATE, { userGUID }) => {
  return {
    ...state,
    userIdSearchByAdmin: userGUID,
  };
};

export const setConfirmationView = (
  state = INITIAL_STATE,
  { confirmationView }
) => {
  return {
    ...state,
    isConfirmationView: confirmationView,
  };
};

export const setSelectedAnswerCount = (state = INITIAL_STATE, { count }) => {
  return {
    ...state,
    selectedAnswerCount: count,
  };
};

export const setBackButtonClickCount = (
  state = INITIAL_STATE,
  { backCount }
) => {
  return {
    ...state,
    backButtonClickCount: backCount,
  };
};
export const setAnswerCount = (state = INITIAL_STATE, { answerCount }) => {
  return {
    ...state,
    totalAnswerCount: answerCount,
  };
};

export const setPrefillEmail = (state = INITIAL_STATE, { prefillEmail }) => {
  return {
    ...state,
    prefillEmail: prefillEmail,
  };
};

export const decrementSelectedAnswerCount = (state = INITIAL_STATE) => {
  return {
    ...state,
    selectedAnswerCount: state.selectedAnswerCount - 1,
  };
};

export const resetSelectedAnswerCount = (state = INITIAL_STATE) => {
  return {
    ...state,
    selectedAnswerCount: 0,
    totalAnswerCount: 0,
    isQuizComplete: false,
  };
};

export const setUserInformation = (
  state = INITIAL_STATE,
  {
    payload: {
      userGUID,
      email,
      parentUserGuid,
      gender,
      countryCD,
      currencyCD,
      ipAddress,
      isPremium,
    },
  }
) => {
  return {
    ...state,
    userGUID: userGUID !== undefined ? userGUID : state.userGUID,
    email: email !== undefined ? email : state.email,
    parentUserGuid:
      parentUserGuid !== undefined ? parentUserGuid : state.parentUserGuid,
    gender: gender !== undefined ? gender : state.gender,
    countryCD: countryCD !== undefined ? countryCD : state.countryCD,
    currencyCD: currencyCD !== undefined ? currencyCD : state.currencyCD,
    ipAddress: ipAddress !== undefined ? ipAddress : state.ipAddress,
    isPremium: isPremium !== undefined ? isPremium : state.isPremium,
  };
};
export const setSelectedPlan = (state = INITIAL_STATE, { selectedPlan }) => {
  return {
    ...state,
    selectedPlan,
  };
};

export const setUserId = (state = INITIAL_STATE, { userGUID }) => {
  return {
    ...state,
    userGUID,
  };
};

export const setAssessmentId = (state = INITIAL_STATE, { assessmentId }) => {
  return {
    ...state,
    assessmentId,
  };
};

export const setAssessmentAttemptId = (
  state = INITIAL_STATE,
  { assessmentAttemptId }
) => {
  return {
    ...state,
    assessmentAttemptId,
  };
};
export const setAssessmentMapId = (
  state = INITIAL_STATE,
  { assessmentMapId }
) => {
  console.log({ reducer: assessmentMapId });
  return {
    ...state,
    assessmentMapId,
  };
};

export const ResetApp = (state = INITIAL_STATE) => {
  return {
    userGUID: "",
    email: "",
    gender: "",
    parentUserGuid: "",
    isPremium: false,
    countryCD: state.countryCD || "",
    currencyCD: state.currencyCD || "",
    ipAddress: state.ipAddress || "",
    totalQuestions: 0,
    selectedAnswerCount: 0,
    totalAnswerCount: 0,
    selectedPlan: {},
    assessmentId: "2FAFF0C7-50A3-4827-BAA1-CC70892FA9F2",
    assessmentAttemptId: "",
    isQuizComplete: false,
    isConfirmationView: false,
    backButtonClickCount: 0,
    isGuestUser: false,
    prefillEmail: "",
    userIdSearchByAdmin: "",
  };
};

export const HANDLERS = {
  [Types.SET_USERINFO]: setUserInformation,
  [Types.SET_NUMBER_OF_QUESTIONS]: setNumberOfQuestions,
  [Types.SET_QUIZ_COMPLETE]: setQuizComplete,
  [Types.SET_SELECTED_ANSWER_COUNT]: setSelectedAnswerCount,
  [Types.RESET_SELECTED_ANSWER_COUNT]: resetSelectedAnswerCount,
  [Types.DECREMENT_SELECTED_ANSWER_COUNT]: decrementSelectedAnswerCount,
  [Types.SET_SELECTED_PLAN]: setSelectedPlan,
  [Types.SET_USERID]: setUserId,
  [Types.SET_ASSESSMENT_ID]: setAssessmentId,
  [Types.SET_ASSESSMENT_ATTEMPT_ID]: setAssessmentAttemptId,
  [Types.SET_CONFIRMATION_VIEW]: setConfirmationView,
  [Types.SET_ANSWER_COUNT]: setAnswerCount,
  [Types.RESET_APP]: ResetApp,
  [Types.SET_BACk_BUTTON_CLICK_COUNT]: setBackButtonClickCount,
  [Types.SET_GUEST_USER]: setGuestUser,
  [Types.SET_PREFILL_EMAIL]: setPrefillEmail,
  [Types.SET_USER_GUID_BY_ADMIN_USER]: setUserIdSearchByAdmin,
  [Types.SET_ASSESSMENT_MAP_ID]: setAssessmentMapId,
};

export default createReducer(INITIAL_STATE, HANDLERS);
